import Api from "../../config/Api";
import { AuthCredential, UserRespone, UserSignup } from "./types";

async function login(credential: AuthCredential): Promise<UserRespone> {
  const response = await Api.post("auth/login", credential);

  return response.data;
}

async function register(user: UserSignup): Promise<UserRespone> {
  const response = await Api.post("auth/register", user);

  return response.data;
}

async function changePassword(credential: UserSignup): Promise<void> {
  const response = await Api.put("auth/" + credential._id, {
    password: credential.password,
  });

  return response.data;
}

async function getCurrentUser(signal?: AbortSignal) {
  const response = await Api.get("auth/me", {
    signal,
  });

  return response.data;
}

export default {
  getCurrentUser,
  login,
  register,
  changePassword,
};
